var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#bababa",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    stroke: "#bababa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.679,9.583h-56c-2.209,0-5.096,0.25-5.096,4.346v42c0,2.209,0.563,3.654,4.096,3.654h57 c2.209,0,2.904-1.445,2.904-3.654v-42C66.583,11.72,65.888,9.583,63.679,9.583z M62.583,13.583v5h-56v-5H62.583z M6.583,55.583v-35 h56v35H6.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.988,24.583H13.176c-2.218,0-2.593,1-2.593,3.169v21c0,1.104,0.488,1.831,1.593,1.831h16.813 c1.104,0,1.595,0.273,1.595-0.831v-22C30.583,26.647,31.021,24.583,28.988,24.583z M28.583,48.583h-16v-22h16V48.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.417,26.583h12c0.553,0,1-0.447,1-1s-0.447-1-1-1h-12c-0.553,0-1,0.447-1,1S32.864,26.583,33.417,26.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.417,24.583h-9c-0.553,0-1,0.447-1,1s0.447,1,1,1h9c0.553,0,1-0.447,1-1S58.97,24.583,58.417,24.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.417,31.583h6c0.553,0,1-0.447,1-1s-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1S32.864,31.583,33.417,31.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.417,17.583h1c0.553,0,1-0.447,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.447-1,1S13.864,17.583,14.417,17.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.417,17.583h1c0.553,0,1-0.447,1-1s-0.447-1-1-1h-1c-0.553,0-1,0.447-1,1S52.864,17.583,53.417,17.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.417,29.583h-7c-0.553,0-1,0.447-1,1s0.447,1,1,1h7c0.553,0,1-0.447,1-1S50.97,29.583,50.417,29.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.417,36.583h10c0.553,0,1-0.447,1-1s-0.447-1-1-1h-10c-0.553,0-1,0.447-1,1S32.864,36.583,33.417,36.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.417,35.583c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1s-0.447-1-1-1h-7C46.864,34.583,46.417,35.03,46.417,35.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.417,29.583h-4c-0.553,0-1,0.447-1,1s0.447,1,1,1h4c0.553,0,1-0.447,1-1S58.97,29.583,58.417,29.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.417,44.583h8c0.553,0,1-0.447,1-1s-0.447-1-1-1h-8c-0.553,0-1,0.447-1,1S32.864,44.583,33.417,44.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.417,42.583h-13c-0.553,0-1,0.447-1,1s0.447,1,1,1h13c0.553,0,1-0.447,1-1S58.97,42.583,58.417,42.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.417,47.583h-15c-0.553,0-1,0.447-1,1s0.447,1,1,1h15c0.553,0,1-0.447,1-1S48.97,47.583,48.417,47.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.417,47.583h-6c-0.553,0-1,0.447-1,1s0.447,1,1,1h6c0.553,0,1-0.447,1-1S58.97,47.583,58.417,47.583z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.efab3a5f110eadf49415522b0eb4c274.svg";
export { ForwardRef as ReactComponent };